/*
 * @Author: panweikang
 * @Date: 2024-01-10 16:42:51
 * @LastEditTime: 2025-09-06 21:23:55
 * @Description:
 */
import { jsConfigApi } from '../api/yearEndReportApi'
let wxconfig = async (openId) => {
  let res = await jsConfigApi({
    url: window.location.href.split('#')[0],
    // url: 'http://activity.ixuanzhi.com',
  })
  window.wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    ...res,
    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 必填，需要使用的JS接口列表
    openTagList: ['wx-open-launch-weapp'],
  })

  window.wx.ready(() => {
    window.wx.updateAppMessageShareData({
      title: '瑞莱博2025年物流地产报告',
      desc: `聚焦华东、华南两大核心市场，抽丝剥茧，以点及面。让您如身临其境般感知市场的每一次脉动！`,
      // link: `http://activity.ixuanzhi.com/rlb/YearEndReport/0?shareOpenId=${openId}`,
      link: `${window.location.origin}/rlb/YearMiddleReport2025`, //?shareOpenId=${openId}`,
      imgUrl: `${window.location.origin}/static/share.png`,
      success: () => {
        console.log('分享朋友配置成功')
      },
      fail: () => {
        console.log('分享朋友配置失败')
      },
    })

    window.wx.updateTimelineShareData({
      title: '瑞莱博2025年物流地产报告', // 分享标题
      desc: '聚焦华东、华南两大核心市场，抽丝剥茧，以点及面。让您如身临其境般感知市场的每一次脉动！',
      link: `${window.location.origin}/rlb/YearMiddleReport2025`, //?shareOpenId=${openId}`,
      imgUrl: `${window.location.origin}/static/share.png`,
      success: () => {
        console.log('分享朋友圈配置成功')
      },
      fail: () => {
        console.log('分享朋友圈配置失败')
      },
    })
  })

  window.wx.error(function (res) {
    console.log(res)
  })
}

export let wxconfigNew = async (messageOpiton, timelineOption) => {
  let res = await jsConfigApi({
    url: window.location.href.split('#')[0],
    // url: 'http://activity.ixuanzhi.com',
  })
  window.wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    ...res,
    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 必填，需要使用的JS接口列表
    openTagList: ['wx-open-launch-weapp'],
  })

  window.wx.ready(() => {
    window.wx.updateAppMessageShareData({
      // title: 'title',
      // desc: `desc`,
      // // link: `http://activity.ixuanzhi.com/rlb/YearEndReport/0?shareOpenId=${openId}`,
      // link: `${window.location.origin}/rlb/YearMiddleReport2024/0?shareOpenId=${openId}`,
      // imgUrl: `${window.location.origin}/static/share.png`,
      ...messageOpiton,
      success: () => {
        console.log('分享朋友配置成功')
      },
      fail: () => {
        console.log('分享朋友配置失败')
      },
    })

    window.wx.updateTimelineShareData({
      // title: '瑞莱博2023年物流地产年度报告', // 分享标题
      // desc: '四大城市群三大篇章，核心数据盘点，亮点趋势洞见，一键解锁市场变幻！',
      // link: `${window.location.origin}/rlb/YearMiddleReport2024/0?shareOpenId=${openId}`,
      // imgUrl: `${window.location.origin}/static/share.png`,
      ...timelineOption,
      success: () => {
        console.log('分享朋友圈配置成功')
      },
      fail: () => {
        console.log('分享朋友圈配置失败')
      },
    })
  })

  window.wx.error(function (res) {
    console.log(res)
  })
}
export default wxconfig
